@if (!loading) {
  <div style="height: 100%">
    <router-outlet></router-outlet>
  </div>
}
@if (loading) {
  <div style="height: 100%; position: relative;">
    <fsi-loading-indicator></fsi-loading-indicator>
  </div>
}


